import styled from 'styled-components'

export const AnswerContent = styled.div`
  white-space: normal;
  padding: 8px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`
